import React from 'react';
import { GiPrayer, GiDoorRingHandle } from 'react-icons/gi';
import { BiBible } from 'react-icons/bi';
import { BsPersonHearts } from 'react-icons/bs';
import Heading from './Heading';
import { useFirebaseData } from '../../hooks/useFirebaseData';

const icons = {
  prayer: GiPrayer,
  bible: BiBible,
  door: GiDoorRingHandle,
  person: BsPersonHearts
};

export default function Services() {
  const { data: servicesData, loading: servicesLoading } = useFirebaseData('services');
  const { data: headerData, loading: headerLoading } = useFirebaseData('servicesHeader');
  const headerContent = headerData[0] || {};

  if (servicesLoading || headerLoading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className='w-full max-w-6xl mx-auto pb-28'>
      <Heading 
        title={headerContent.title || "S E R V I C E S"}
        subtitle={headerContent.subtitle || "Eglise Evangelique des Amis au Rwanda (EEAR)"}
        description={headerContent.description || "COME WORSHIP WITH US ON WEEKDAYS AND SUNDAYS ANYWHERE IN RWANDA"}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6">
        {servicesData.map((service) => (
          <div key={service.id} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-all duration-300">
            <div className="text-4xl text-[#ffd615] mb-4 flex justify-center">
              {icons[service.icon] || <GiPrayer />}
            </div>
            <h3 className="text-xl font-semibold text-center mb-4">{service.name}</h3>
            <div className="text-gray-600">
              <p className="font-medium mb-2">Location: {service.location}</p>
              <p className="mb-2">
                <span className="font-medium">Sunday Service:</span><br />
                {service.sundayTimes}
              </p>
              {service.weekdayTimes && (
                <p>
                  <span className="font-medium">Weekday Services:</span><br />
                  {service.weekdayTimes}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
